<template>
  <div class="container">
    <content-title :nav="nav"></content-title>

    <!-- 待办统计 -->
    <div class="summary">
      <div class="summary-item" @click="filterByStatus(0)">
        <div class="label">待审核</div>
        <div class="value warn">{{ summary.wait_audit_count || 0 }} 单</div>
      </div>
      <div class="summary-item" @click="filterByStatus(1)">
        <div class="label">打款中</div>
        <div class="value">{{ summary.paying_count || 0 }} 单</div>
      </div>
      <div class="summary-item" @click="filterByStatus(5)">
        <div class="label">待人工打款</div>
        <div class="value warn">{{ summary.wait_transfer_count || 0 }} 单</div>
      </div>
      <div class="summary-item" @click="filterByStatus(4)">
        <div class="label">失败待重试</div>
        <div class="value danger">{{ summary.fail_count || 0 }} 单</div>
      </div>
      <div class="summary-item">
        <div class="label">冻结金额</div>
        <div class="value">¥{{ summary.frozen_amount || "0.00" }}</div>
      </div>
      <div class="summary-item">
        <div class="label">累计实付</div>
        <div class="value">¥{{ summary.paid_amount || "0.00" }}</div>
      </div>
    </div>

    <el-form :inline="true">
      <el-form-item label="状态">
        <el-select v-model="query.status" placeholder="选择" clearable>
          <el-option
            v-for="(item, i) in statusOptions"
            :key="i"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="用户ID">
        <el-input
          v-model="query.user_id"
          placeholder="用户ID"
          clearable
          style="width: 130px"
        ></el-input>
      </el-form-item>
      <el-form-item label="单据ID">
        <el-input
          v-model="query.id"
          placeholder="单据ID"
          clearable
          style="width: 130px"
        ></el-input>
      </el-form-item>
      <el-form-item label="提现单号">
        <el-input
          v-model="query.order_no"
          placeholder="精确匹配"
          clearable
          style="width: 180px"
        ></el-input>
      </el-form-item>
      <el-form-item label="申请时间">
        <el-date-picker
          v-model="query.createTime"
          type="daterange"
          range-separator="至"
          value-format="yyyy-MM-dd"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getList(1)">搜索</el-button>
      </el-form-item>
    </el-form>

    <auto-table
      :DataList="DataList"
      :option="Option"
      :total="Total"
      @changePage="getList"
    >
      <template #payee="{ row }">
        <div>{{ row.payee_name }}</div>
        <div>{{ row.payee_account }}</div>
      </template>
      <template #status="{ row }">
        <el-tag size="small" type="warning" v-if="row.status === 0"
          >待审核</el-tag
        >
        <el-tag size="small" v-if="row.status === 1">打款中</el-tag>
        <el-tag size="small" type="danger" v-if="row.status === 2"
          >已拒绝</el-tag
        >
        <el-tag size="small" type="success" v-if="row.status === 3"
          >成功</el-tag
        >
        <el-tag size="small" type="danger" v-if="row.status === 4"
          >失败</el-tag
        >
        <el-tag size="small" type="warning" v-if="row.status === 5"
          >待人工打款</el-tag
        >
        <el-tag size="small" type="info" v-if="row.status === 6">已撤销</el-tag>
      </template>
      <template #audit_time="{ row }">
        {{ formatTime(row.audit_time) }}
      </template>
      <template #create_time="{ row }">
        {{ formatTime(row.create_time) }}
      </template>
      <template #handle="{ row }">
        <el-button size="small" type="primary" @click="openDetail(row)"
          >详情</el-button
        >
        <el-button
          size="small"
          type="success"
          v-if="row.status === 0"
          @click="openAudit(row)"
          >审核</el-button
        >
        <el-button
          size="small"
          type="warning"
          v-if="row.status === 4 && row.channel === 1"
          @click="retryTransfer(row)"
          >重试打款</el-button
        >
        <el-button
          size="small"
          type="success"
          v-if="row.status === 5"
          @click="openTransfer(row)"
          >提交打款记录</el-button
        >
        <el-button
          size="small"
          type="warning"
          v-if="row.status === 1 || row.status === 5"
          @click="openResolve(row)"
          >人工核对</el-button
        >
        <el-button size="small" type="info" @click="viewPayeeAccount(row)"
          >查看账号</el-button
        >
      </template>
    </auto-table>

    <!-- 单据详情 -->
    <el-dialog title="提现单详情" :visible.sync="detailShow" width="60%">
      <el-descriptions :column="2" border>
        <el-descriptions-item label="单据ID">{{
          detail.id
        }}</el-descriptions-item>
        <el-descriptions-item label="提现单号">{{
          detail.order_no
        }}</el-descriptions-item>
        <el-descriptions-item label="状态">{{
          statusText(detail.status)
        }}</el-descriptions-item>
        <el-descriptions-item label="用户ID">{{
          detail.user_id
        }}</el-descriptions-item>
        <el-descriptions-item label="申请金额(元)">{{
          detail.amount
        }}</el-descriptions-item>
        <el-descriptions-item label="手续费(元)">{{
          detail.fee
        }}</el-descriptions-item>
        <el-descriptions-item label="实际到账(元)">{{
          detail.actual_amount
        }}</el-descriptions-item>
        <el-descriptions-item label="收款方式">{{
          detail.payee_type === 3 ? "银行卡" : "支付宝"
        }}</el-descriptions-item>
        <el-descriptions-item label="收款人">{{
          detail.payee_name
        }}</el-descriptions-item>
        <el-descriptions-item label="收款账号(脱敏)">{{
          detail.payee_account
        }}</el-descriptions-item>
        <el-descriptions-item label="打款渠道">{{
          detail.channel === 2 ? "银行卡(人工)" : "支付宝(线上)"
        }}</el-descriptions-item>
        <el-descriptions-item label="开户行">{{
          detail.bank_name || "-"
        }}</el-descriptions-item>
        <el-descriptions-item label="开户支行">{{
          detail.bank_branch || "-"
        }}</el-descriptions-item>
        <el-descriptions-item label="审核人">{{
          detail.audit_operator_id || "-"
        }}</el-descriptions-item>
        <el-descriptions-item label="审核时间">{{
          formatTime(detail.audit_time)
        }}</el-descriptions-item>
        <el-descriptions-item label="审核意见/拒绝原因">{{
          detail.audit_remark || "-"
        }}</el-descriptions-item>
        <el-descriptions-item label="打款时间">{{
          formatTime(detail.transfer_time)
        }}</el-descriptions-item>
        <el-descriptions-item label="转账凭证">
          <el-image
            v-if="detail.transfer_voucher"
            style="width: 100px; height: 100px"
            :src="detail.transfer_voucher"
            :preview-src-list="[detail.transfer_voucher]"
          ></el-image>
          <span v-else>-</span>
        </el-descriptions-item>
        <el-descriptions-item label="失败原因">{{
          detail.fail_reason || "-"
        }}</el-descriptions-item>
        <el-descriptions-item label="申请时间">{{
          formatTime(detail.create_time)
        }}</el-descriptions-item>
        <el-descriptions-item label="更新时间">{{
          formatTime(detail.update_time)
        }}</el-descriptions-item>
      </el-descriptions>
      <span slot="footer" class="dialog-footer">
        <el-button @click="detailShow = false">关闭</el-button>
      </span>
    </el-dialog>

    <!-- 审核弹窗 -->
    <el-dialog title="提现审核" :visible.sync="auditShow" width="40%">
      <el-form label-width="110px">
        <el-form-item label="提现单号">{{
          curRow.order_no
        }}</el-form-item>
        <el-form-item label="申请金额">
          ¥{{ curRow.amount }}（手续费¥{{ curRow.fee }}，实际到账¥{{
            curRow.actual_amount
          }}）
        </el-form-item>
        <el-form-item label="收款账户">{{
          curRow.payee_name + " " + curRow.payee_account
        }}</el-form-item>
        <el-form-item label="审核结果">
          <el-radio-group v-model="auditResult">
            <el-radio label="approved">通过并打款</el-radio>
            <el-radio label="rejected">拒绝</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="" v-if="auditResult === 'approved'">
          <div v-if="curRow.channel === 2" style="color: #909399">
            银行卡单：通过后转为「待人工打款」，需线下转账后提交打款记录
          </div>
          <div v-else style="color: #f56c6c">
            通过后将立即调用支付宝转账（真实打款），请谨慎操作
          </div>
        </el-form-item>
        <el-form-item
          :label="auditResult === 'rejected' ? '拒绝原因' : '审核意见'"
          :required="auditResult === 'rejected'"
        >
          <el-input
            type="textarea"
            :rows="4"
            v-model="audit_remark"
            maxlength="200"
            show-word-limit
            :placeholder="
              auditResult === 'rejected'
                ? '拒绝原因（将展示给用户）'
                : '审核意见（选填）'
            "
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="auditShow = false">取 消</el-button>
        <el-button
          type="primary"
          :loading="auditLoading"
          :disabled="auditLoading"
          @click="submitAudit"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <!-- 人工核对 -->
    <el-dialog title="打款结果人工核对" :visible.sync="resolveShow" width="40%">
      <el-form label-width="110px">
        <el-form-item label="提现单号">{{
          curRow.order_no
        }}</el-form-item>
        <el-form-item label="核对结果">
          <el-radio-group v-model="resolveResult">
            <el-radio label="paid">已到账</el-radio>
            <el-radio label="unpaid">未到账</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="">
          <div style="color: #f56c6c">
            必须先核对支付宝账单再操作：若实际已到账却选「未到账」，金额将退回用户，属于资金损失
          </div>
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            type="textarea"
            :rows="3"
            v-model="resolve_remark"
            maxlength="200"
            show-word-limit
            placeholder="如：支付宝账单已核对（选填）"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="resolveShow = false">取 消</el-button>
        <el-button
          type="primary"
          :loading="resolveLoading"
          :disabled="!resolveResult"
          @click="submitResolve"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <!-- 提交打款记录（银行卡） -->
    <el-dialog
      title="提交打款记录（银行卡）"
      :visible.sync="transferShow"
      width="40%"
    >
      <el-form label-width="110px">
        <el-form-item label="提现单号">{{
          curRow.order_no
        }}</el-form-item>
        <el-form-item label="应打款金额">
          <span style="color: #f56c6c; font-weight: bold"
            >¥{{ curRow.actual_amount }}</span
          >
        </el-form-item>
        <el-form-item label="收款人">{{
          curRow.payee_name
        }}</el-form-item>
        <el-form-item label="收款账号">
          {{ curRow.payee_account }}
          <el-button type="text" @click="viewPayeeAccount(curRow)"
            >查看完整账号</el-button
          >
        </el-form-item>
        <el-form-item label="开户行">{{
          (curRow.bank_name || "-") + " " + (curRow.bank_branch || "")
        }}</el-form-item>
        <el-form-item label="打款凭证" required>
          <avatar-uploader
            @getImgUrl="(v) => (transfer_voucher = v)"
            :url="transfer_voucher"
          ></avatar-uploader>
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            type="textarea"
            :rows="3"
            v-model="transfer_remark"
            maxlength="200"
            show-word-limit
            placeholder="选填，为空默认「人工打款完成」"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="transferShow = false">取 消</el-button>
        <el-button
          type="primary"
          :loading="transferLoading"
          @click="submitTransfer"
          >确认打款完成</el-button
        >
      </span>
    </el-dialog>

    <!-- 完整收款账号（敏感） -->
    <el-dialog
      title="收款账号（敏感信息）"
      :visible.sync="payeeShow"
      width="35%"
      @closed="clearPayeeTimer"
    >
      <el-descriptions :column="1" border>
        <el-descriptions-item label="提现单号">{{
          payeeInfo.order_no
        }}</el-descriptions-item>
        <el-descriptions-item label="收款人">{{
          payeeInfo.payee_name
        }}</el-descriptions-item>
        <el-descriptions-item label="收款账号">
          <span style="font-weight: bold">{{
            payeeInfo.payee_account
          }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="实际到账"
          >¥{{ payeeInfo.actual_amount }}</el-descriptions-item
        >
      </el-descriptions>
      <div v-if="payeeAccountCountdown > 0" style="margin-top: 10px;color: #f56c6c">
        {{ payeeAccountCountdown }} 秒后自动关闭
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="payeeShow = false"
          >已知晓，关闭</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      nav: { firstNav: "财务管理中心", secondNav: "用户提现管理" },
      DataList: [],
      Total: 0,
      summary: {},
      query: {
        status: "",
        user_id: "",
        id: "",
        order_no: "",
        createTime: [],
      },
      statusOptions: [
        { value: 0, label: "待审核" },
        { value: 1, label: "打款中" },
        { value: 2, label: "已拒绝" },
        { value: 3, label: "成功" },
        { value: 4, label: "失败" },
        { value: 5, label: "待人工打款" },
        { value: 6, label: "已撤销" },
      ],
      Option: [
        { name: "ID", value: "id", width: "80px" },
        { name: "提现单号", value: "order_no", width: "180px" },
        { name: "用户ID", value: "user_id" },
        { name: "申请金额(元)", value: "amount" },
        { name: "实际到账(元)", value: "actual_amount" },
        { name: "收款账户", value: "payee", type: "custom", width: "180px" },
        { name: "状态", value: "status", type: "custom" },
        { name: "审核时间", value: "audit_time", type: "custom", width: "160px" },
        { name: "申请时间", value: "create_time", type: "custom", width: "160px" },
        { name: "操作", value: "handle", type: "custom", width: "320px" },
      ],
      curRow: {},
      detailShow: false,
      detail: {},
      auditShow: false,
      auditResult: "approved",
      audit_remark: "",
      auditLoading: false,
      resolveShow: false,
      resolveResult: "",
      resolve_remark: "",
      resolveLoading: false,
      transferShow: false,
      transfer_voucher: "",
      transfer_remark: "",
      transferLoading: false,
      payeeShow: false,
      payeeInfo: {},
      payeeAccountCountdown: 0,
      payeeTimer: null,
      adminInfo: JSON.parse(localStorage.getItem("managerInfo")),
    };
  },

  mounted() {
    this.getSummary();
    this.getList(1);
  },

  beforeDestroy() {
    this.clearPayeeTimer();
  },

  methods: {
    statusText(v) {
      const map = {
        0: "待审核",
        1: "打款中",
        2: "已拒绝",
        3: "成功",
        4: "失败",
        5: "待人工打款",
        6: "已撤销",
      };
      return map[v] !== undefined ? map[v] : v;
    },
    formatTime(v) {
      if (!v) return "-";
      if (typeof v === "number") {
        let d = new Date(v);
        let p = (n) => (n < 10 ? "0" + n : "" + n);
        return (
          d.getFullYear() +
          "-" +
          p(d.getMonth() + 1) +
          "-" +
          p(d.getDate()) +
          " " +
          p(d.getHours()) +
          ":" +
          p(d.getMinutes()) +
          ":" +
          p(d.getSeconds())
        );
      }
      return v;
    },
    filterByStatus(v) {
      this.query.status = v;
      this.getList(1);
    },
    getSummary() {
      this.$axios({
        url: "/user/userWalletWithdraw/summary",
      }).then((res) => {
        this.summary = res.data.data || {};
      });
    },
    openDetail(row) {
      this.$axios({
        url: "/user/userWalletWithdraw/detail",
        params: {
          id: row.id,
        },
      }).then((res) => {
        this.detail = res.data.data || {};
        this.detailShow = true;
      });
    },
    openAudit(row) {
      this.curRow = row;
      this.auditResult = "approved";
      this.audit_remark = "";
      this.auditShow = true;
    },
    submitAudit() {
      if (this.auditResult === "rejected" && !this.audit_remark) {
        this.$message("拒绝时必须填写拒绝原因");
        return;
      }
      this.auditLoading = true;
      this.$axios({
        url: "/user/userWalletWithdraw/audit",
        method: "post",
        params: {
          id: this.curRow.id,
          audit_result: this.auditResult,
          audit_operator_id: this.adminInfo.id,
          audit_remark: this.audit_remark,
        },
      })
        .then((res) => {
          this.auditLoading = false;
          let data = res.data.data;
          if (this.auditResult === "approved") {
            if (data && data.status === 3) {
              this.$message.success("打款成功");
            } else if (data && data.status === 5) {
              this.$message.success(
                "已通过，转为待人工打款，请线下转账后提交打款记录"
              );
            } else {
              this.$message("打款结果未知，请人工核对");
            }
          } else {
            this.$message.success("已拒绝，金额已解冻");
          }
          this.auditShow = false;
          this.getSummary();
          this.getList(1);
        })
        .catch(() => {
          this.auditLoading = false;
          this.getSummary();
          this.getList(1);
        });
    },
    retryTransfer(row) {
      this.$confirm(
        "重试将重新冻结该笔金额并再次发起支付宝打款，确定重试吗",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.$axios({
            url: "/user/userWalletWithdraw/retryTransfer",
            method: "post",
            params: {
              id: row.id,
              operator_id: this.adminInfo.id,
            },
          }).then((res) => {
            let data = res.data.data;
            this.$message(
              data && data.status === 3 ? "打款成功" : "已重新发起打款，请关注结果"
            );
            this.getSummary();
            this.getList(1);
          });
        })
        .catch(() => {});
    },
    openResolve(row) {
      this.curRow = row;
      this.resolveResult = "";
      this.resolve_remark = "";
      this.resolveShow = true;
    },
    submitResolve() {
      if (!this.resolveResult) {
        this.$message("请选择核对结果");
        return;
      }
      this.resolveLoading = true;
      this.$axios({
        url: "/user/userWalletWithdraw/resolveUnknown",
        method: "post",
        params: {
          id: this.curRow.id,
          result: this.resolveResult,
          operator_id: this.adminInfo.id,
          remark: this.resolve_remark,
        },
      })
        .then((res) => {
          this.$message.success(
            this.resolveResult === "paid"
              ? "已确认到账"
              : "已确认未到账，金额已解冻"
          );
          this.resolveShow = false;
          this.resolveLoading = false;
          this.getSummary();
          this.getList(1);
        })
        .catch(() => {
          this.resolveLoading = false;
        });
    },
    openTransfer(row) {
      this.curRow = row;
      this.transfer_voucher = "";
      this.transfer_remark = "";
      this.transferShow = true;
    },
    submitTransfer() {
      if (!this.transfer_voucher) {
        this.$message("请上传打款凭证");
        return;
      }
      this.transferLoading = true;
      this.$axios({
        url: "/user/userWalletWithdraw/confirmTransfer",
        method: "post",
        params: {
          id: this.curRow.id,
          transfer_voucher: this.transfer_voucher,
          operator_id: this.adminInfo.id,
          remark: this.transfer_remark,
        },
      })
        .then((res) => {
          let data = res.data.data;
          this.$message(
            data && data.status === 3 ? "打款成功" : "提交成功"
          );
          this.transferShow = false;
          this.transferLoading = false;
          this.getSummary();
          this.getList(1);
        })
        .catch(() => {
          this.transferLoading = false;
        });
    },
    viewPayeeAccount(row) {
      this.$confirm(
        "查看完整收款账号属于敏感操作，将被记录审计日志，确定继续吗",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.$axios({
            url: "/user/userWalletWithdraw/viewPayeeAccount",
            method: "post",
            params: {
              id: row.id,
              operator_id: this.adminInfo.id,
            },
          }).then((res) => {
            this.payeeInfo = res.data.data || {};
            this.payeeShow = true;
            this.startPayeeTimer();
          });
        })
        .catch(() => {});
    },
    startPayeeTimer() {
      this.clearPayeeTimer();
      this.payeeAccountCountdown = 60;
      this.payeeTimer = setInterval(() => {
        this.payeeAccountCountdown--;
        if (this.payeeAccountCountdown <= 0) {
          this.payeeShow = false;
          this.clearPayeeTimer();
        }
      }, 1000);
    },
    clearPayeeTimer() {
      if (this.payeeTimer) {
        clearInterval(this.payeeTimer);
        this.payeeTimer = null;
      }
    },
    getList(v) {
      let page = v || 1;
      let params = {
        currentPage: page,
        pageSize: 10,
        status: this.query.status,
        user_id: this.query.user_id || null,
        id: this.query.id || null,
        order_no: this.query.order_no || null,
      };
      if (this.query.createTime !== null && this.query.createTime.length > 0) {
        params.start_time = this.query.createTime[0] + " 00:00:00";
        params.end_time = this.query.createTime[1] + " 23:59:59";
      }
      this.$axios({
        url: "/user/userWalletWithdraw/adminPage",
        params,
      }).then((res) => {
        this.DataList = (res.data.data && res.data.data.rows) || [];
        this.Total = (res.data.data && res.data.data.total) || 0;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.summary {
  display: flex;
  margin-bottom: 20px;
}
.summary-item {
  flex: 1;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  padding: 12px 16px;
  margin-right: 12px;
  cursor: pointer;
  &:last-child {
    margin-right: 0;
  }
  .label {
    color: #909399;
    font-size: 13px;
  }
  .value {
    font-size: 20px;
    font-weight: bold;
    margin-top: 6px;
    &.warn {
      color: #e6a23c;
    }
    &.danger {
      color: #f56c6c;
    }
  }
}
</style>
